// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
	--toastify-color-light: #171717;
	--toastify-color-dark: #171717;
	--toastify-color-info: #3498db;
	--toastify-color-success: #07bc0c;
	--toastify-color-warning: #f1c40f;
	--toastify-color-error: #e74c3c;
	--toastify-color-transparent: rgba(255, 255, 255, 0.7);

	--toastify-icon-color-info: var(--toastify-color-info);
	--toastify-icon-color-success: var(--toastify-color-success);
	--toastify-icon-color-warning: var(--toastify-color-warning);
	--toastify-icon-color-error: var(--toastify-color-error);

	--toastify-toast-width: 320px;
	--toastify-toast-background: #fff;
	--toastify-toast-min-height: 64px;
	--toastify-toast-max-height: 800px;
	--toastify-font-family: sans-serif;
	--toastify-z-index: 9999;

	--toastify-text-color-light: #FFFCFA;
	--toastify-text-color-dark: #fff;

	/* Used only for colored theme */
	--toastify-text-color-info: #fff;
	--toastify-text-color-success: #fff;
	--toastify-text-color-warning: #fff;
	--toastify-text-color-error: #fff;

	--toastify-spinner-color: #616161;
	--toastify-spinner-color-empty-area: #e0e0e0;

	/*  Used when no type is provided */
	--toastify-color-progress-light: linear-gradient(
		to right,
		#4cd964,
		#5ac8fa,
		#007aff,
		#34aadc,
		#5856d6,
		#ff2d55
	);
	/* Used when no type is provided */
	--toastify-color-progress-dark: #bb86fc;
	--toastify-color-progress-info: var(--toastify-color-info);
	--toastify-color-progress-success: var(--toastify-color-success);
	--toastify-color-progress-warning: var(--toastify-color-warning);
	--toastify-color-progress-error: var(--toastify-color-error);

	/* used to control the opacity of the progress trail */
	--toastify-color-progress-bgo: 0.2;
}
`, "",{"version":3,"sources":["webpack://./src/client/Components/shared/Notifier/index.css"],"names":[],"mappings":"AAAA;CACC,+BAA+B;CAC/B,8BAA8B;CAC9B,8BAA8B;CAC9B,iCAAiC;CACjC,iCAAiC;CACjC,+BAA+B;CAC/B,sDAAsD;;CAEtD,sDAAsD;CACtD,4DAA4D;CAC5D,4DAA4D;CAC5D,wDAAwD;;CAExD,6BAA6B;CAC7B,iCAAiC;CACjC,iCAAiC;CACjC,kCAAkC;CAClC,kCAAkC;CAClC,wBAAwB;;CAExB,oCAAoC;CACpC,gCAAgC;;CAEhC,gCAAgC;CAChC,gCAAgC;CAChC,mCAAmC;CACnC,mCAAmC;CACnC,iCAAiC;;CAEjC,iCAAiC;CACjC,4CAA4C;;CAE5C,mCAAmC;CACnC;;;;;;;;EAQC;CACD,kCAAkC;CAClC,uCAAuC;CACvC,0DAA0D;CAC1D,gEAAgE;CAChE,gEAAgE;CAChE,4DAA4D;;CAE5D,sDAAsD;CACtD,kCAAkC;AACnC","sourcesContent":[":root {\n\t--toastify-color-light: #171717;\n\t--toastify-color-dark: #171717;\n\t--toastify-color-info: #3498db;\n\t--toastify-color-success: #07bc0c;\n\t--toastify-color-warning: #f1c40f;\n\t--toastify-color-error: #e74c3c;\n\t--toastify-color-transparent: rgba(255, 255, 255, 0.7);\n\n\t--toastify-icon-color-info: var(--toastify-color-info);\n\t--toastify-icon-color-success: var(--toastify-color-success);\n\t--toastify-icon-color-warning: var(--toastify-color-warning);\n\t--toastify-icon-color-error: var(--toastify-color-error);\n\n\t--toastify-toast-width: 320px;\n\t--toastify-toast-background: #fff;\n\t--toastify-toast-min-height: 64px;\n\t--toastify-toast-max-height: 800px;\n\t--toastify-font-family: sans-serif;\n\t--toastify-z-index: 9999;\n\n\t--toastify-text-color-light: #FFFCFA;\n\t--toastify-text-color-dark: #fff;\n\n\t/* Used only for colored theme */\n\t--toastify-text-color-info: #fff;\n\t--toastify-text-color-success: #fff;\n\t--toastify-text-color-warning: #fff;\n\t--toastify-text-color-error: #fff;\n\n\t--toastify-spinner-color: #616161;\n\t--toastify-spinner-color-empty-area: #e0e0e0;\n\n\t/*  Used when no type is provided */\n\t--toastify-color-progress-light: linear-gradient(\n\t\tto right,\n\t\t#4cd964,\n\t\t#5ac8fa,\n\t\t#007aff,\n\t\t#34aadc,\n\t\t#5856d6,\n\t\t#ff2d55\n\t);\n\t/* Used when no type is provided */\n\t--toastify-color-progress-dark: #bb86fc;\n\t--toastify-color-progress-info: var(--toastify-color-info);\n\t--toastify-color-progress-success: var(--toastify-color-success);\n\t--toastify-color-progress-warning: var(--toastify-color-warning);\n\t--toastify-color-progress-error: var(--toastify-color-error);\n\n\t/* used to control the opacity of the progress trail */\n\t--toastify-color-progress-bgo: 0.2;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
